export var webViewLoaderStyle={
position:'absolute',
width:'100%',
height:'100%'
};
export var loaderStyle={justifyContent:'center'};